export const ACCOUNTING_ACCOUNT_RELATION_LOADINGS = {
  GET_RELATION_LIST: "loadingRelationList",
  GET_ACCOUNT_LIST: "loadingAccountList",
  CREATE: "loadingCreation",
  UPDATE: "loadingUpdate",
  DELETE: "loadingDeletion",
};

const ACCOUNTING_ACCOUNT_RELATION_TYPES = {
  CREATE_ACCOUNTING_ACCOUNT_RELATION: "ACCOUNTING_ACCOUNT_RELATION/CREATE",
  DELETE_ACCOUNTING_ACCOUNT_RELATION: "ACCOUNTING_ACCOUNT_RELATION/DELETE",
  UPDATE_ACCOUNTING_ACCOUNT_RELATION: "ACCOUNTING_ACCOUNT_RELATION/UPDATE",
  GET_ACCOUNTS_FOR_RELATION: "ACCOUNTING_ACCOUNT_RELATION/GET_ACCOUNTS_LIST",
  GET_ACCOUNTING_ACCOUNT_RELATION_LIST: "ACCOUNTING_ACCOUNT_RELATION/GET_LIST",
  RESTORE_INITIAL_STATE: "ACCOUNTING_ACCOUNT_RELATION/RESTORE_INITIAL_STATE",
  SET_ACCOUNTING_ACCOUNT_RELATION_SEARCH_FILTERS: "ACCOUNTING_ACCOUNT_RELATION/SET_SEARCH_FILTERS",
};

export default ACCOUNTING_ACCOUNT_RELATION_TYPES;
